module.exports = __webpack_public_path__ + "wp-content/themes/clarks/img/hide-and-seek.jpg";